import {
  deleteAdminV1StoresStoreIdTaxRatesId,
  getAdminV1StoresStoreIdTaxRates,
  patchAdminV1StoresStoreIdTaxRatesId,
  postAdminV1StoresStoreIdTaxRates,
  type PatchAdminV1StoresStoreIdTaxRatesIdBody,
  type PostAdminV1StoresStoreIdTaxRatesBody,
  type TaxRate,
} from '@nucleus-commerce/api-client/admin';

/** Manual tax rates of one store: a bounded `{ items }` list ordered by priority. */
export const taxApi = {
  list: (storeId: string): Promise<TaxRate[]> =>
    getAdminV1StoresStoreIdTaxRates({ storeId }).then((r) => r.items),
  create: (storeId: string, body: PostAdminV1StoresStoreIdTaxRatesBody): Promise<TaxRate> =>
    postAdminV1StoresStoreIdTaxRates({ storeId }, body),
  update: (
    storeId: string,
    id: string,
    body: PatchAdminV1StoresStoreIdTaxRatesIdBody,
  ): Promise<TaxRate> => patchAdminV1StoresStoreIdTaxRatesId({ storeId, id }, body),
  remove: (storeId: string, id: string): Promise<void> =>
    deleteAdminV1StoresStoreIdTaxRatesId({ storeId, id }),
};
